import { create } from 'zustand'

/**
 * Si el conmutador `⌘K` está abierto.
 *
 * Vive afuera del componente para que se pueda abrir desde otro lado —la barra
 * de búsqueda de la navegación— sin montar un segundo buscador que pudiera
 * buscar distinto. No se persiste: un buscador abierto no sobrevive a recargar.
 */
interface CommandPaletteState {
  open: boolean
  setOpen: (open: boolean) => void
  toggle: () => void
}

export const useCommandPalette = create<CommandPaletteState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  toggle: () => set((state) => ({ open: !state.open })),
}))
